export enum ShortETurnFrameCount {
  None = 'None',
  OneSide = 'OneSide',
  BothSides = 'BothSides',
}
